export default "__VITE_ASSET__d03f9cf4__"